var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeaceHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1429 15.6094C27.5649 15.6094 26.2857 16.9036 26.2857 18.5H25.7143V16.1875C25.7143 14.5911 24.4351 13.2969 22.8571 13.2969C21.2791 13.2969 20 14.5911 20 16.1875V18.5H19.4286V3.46875C19.4286 1.55299 17.8936 0 16 0C14.1064 0 12.5714 1.55299 12.5714 3.46875V18.5H11.602L6.62056 5.66917C5.92813 3.88601 3.93813 3.00842 2.17577 3.70896C0.413341 4.40943 -0.454017 6.42275 0.23834 8.20583L5.5787 21.961L3.35799 23.7584C2.25934 24.6477 1.96406 26.2139 2.6622 27.4498L7.23363 35.5436C7.48352 35.986 7.84458 36.3538 8.28022 36.6095C8.71586 36.8653 9.21059 37 9.71427 37H26.8571C28.183 37 29.3347 36.0772 29.6384 34.7715L31.9241 24.9433C31.9746 24.7264 32 24.5042 32 24.2812V18.5C32 16.9036 30.7209 15.6094 29.1429 15.6094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceHand);
export default __webpack_public_path__ + "static/media/peaceHand.58e94816e1444e6ecfb304710e3f01c1.svg";
export { ForwardRef as ReactComponent };